import { render, staticRenderFns } from "./StolenIdentityCardDialog.vue?vue&type=template&id=8fe5565a&"
import script from "./StolenIdentityCardDialog.vue?vue&type=script&lang=js&"
export * from "./StolenIdentityCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCardTitle,VCheckbox})
